import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'
import KEYCODE from 'keycode'

import ClickOutside from '../clickOutside'
import OnKeyDown from '../onKeyDown'
import FiltersMultiSelectPanel from './filtersPanel/multiSelect'
import { reportOpenSearchFilterPanel } from '../../../../common/analytics/filtersAnalytics'
import PaletteIcon from '../../../shared/components/icons/palette'

class FiltersColors extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showPanel: false
    }

    this.togglePanel = this.togglePanel.bind(this)
    this.onKeyDownHandler = this.onKeyDownHandler.bind(this)
  }

  onKeyDownHandler(event) {
    if (event.keyCode === KEYCODE('esc')) {
      this.togglePanel()
    }
  }

  togglePanel() {
    if (!this.state.showPanel) {
      reportOpenSearchFilterPanel('colors')
    }
    this.setState({
      showPanel: !this.state.showPanel
    })
  }

  render() {
    const { showPanel } = this.state
    const {
      items,
      locationParams,
      isAtTop,
      isAtBottom,
      makeSearchLink
    } = this.props

    const chosenColors = locationParams.colors || ''

    const renderChosenColors = () => {
      if (chosenColors === '') {
        return (
          <ul className="search-facet-listing">
            {items.map((item, index) => {
              return (
                <li key={index}>
                  <div className="search-facet-listing__link">
                    <span className="search-facet-listing__label">
                      {item.key}
                    </span>
                    <span className="search-facet-result-count">
                      {item.count}
                    </span>
                  </div>
                </li>
              )
            })}
          </ul>
        )
      } else {
        return (
          <div className="search-facet-panel__status fds-u-is-hidden--no-js">
            <div className="search-facet-panel__status-row">
              <div className="search-facet-panel__status-title">
                {chosenColors.split(',').join(', ')}
              </div>
            </div>
          </div>
        )
      }
    }

    const panelHeaderClassNames = classNames({
      'search-facet-panel__header--start': isAtTop,
      'search-facet-panel__header': !isAtTop,
      'search-facet-panel__header--end': isAtBottom,
      'is-active': showPanel
    })

    return (
      <div className="search-facet--no-margin" id="colors-filter">
        <div className={panelHeaderClassNames} onClick={this.togglePanel}>
          <h2>
            <PaletteIcon /> Colors
          </h2>
          {renderChosenColors()}
        </div>

        {showPanel && (
          <OnKeyDown onKeyDown={this.onKeyDownHandler}>
            <ClickOutside onClickOutside={this.togglePanel}>
              <FiltersMultiSelectPanel
                type="colors"
                showPanel={showPanel}
                items={items}
                parsedLocation={locationParams}
                makeSearchLink={makeSearchLink}
                togglePanel={this.togglePanel}
              />
            </ClickOutside>
          </OnKeyDown>
        )}
      </div>
    )
  }
}

FiltersColors.propTypes = {
  locationParams: PropTypes.object.isRequired,
  items: PropTypes.array,
  makeSearchLink: PropTypes.func.isRequired
}

export default FiltersColors
